module.exports = __webpack_public_path__ + "static/img/qr_code.9f1394e.png";